/**
 * This file is part of DNG
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * @author Nicolò Martini <nicmartnic@gmail.com>
 */

require(["common"], function() {
	require(["jquery", "dng-common", "jquery-colorbox", "dng-comments"], function($, dng) {

		$(document).ready(function(){
			if (window.location.hash){
				var pieces = window.location.hash.split('_');
				if (pieces[0] === '#issue' && typeof pieces[1]!== 'undefined'){
					var issueId = pieces[1];
					$('#accordion a[data-target="#issues"]').tab('show');
					var issueYearLi = $('a[name=issue_'+issueId+']').closest('.issuesYears > li');
					var year = issueYearLi.find('a.issueYear');
					var spoglioLink = issueYearLi.find('a.spoglioLink');
					if (year.length)
						year.trigger('click');
					if (spoglioLink.length)
						spoglioLink.trigger('click');
				}
			}

			//Colorbox
			var images = $('.manifestation-images a');

			if (images.length > 0) {
				images.colorbox({
					photo:true,
					rel: 'manifestation-images',
					current: "{current}/{total}",
					scalePhotos: true,
					maxWidth: '65%'
				});
			}

			//Activate comments tab when comments content is refreshed
			$('body').on('refreshed', '#comments', function(){
				$(this).addClass('active');
				$(this).scrollTo();
			});
			//Dom events to semantic events mapping
			$('body').on('submit', '#Form_ReplyForm', function(event){
				event.preventDefault();
				var data = $(this).toHash();
				$(this).trigger('comment-creation-request', [data.ManifestationID, data]);
			});

			$('body').on('change', 'form.badge-form', function(event) {
				var data = $(this).closest('form').toHash();
				if (typeof data['showabstract'] == 'undefined') {
					data['showabstract'] = '0';
				}
				$(this).trigger('manifestation-embed-change', [data]);
			});

			//Semantic events dom-specific handlers
			$('body').on('comment-created', '#Form_ReplyForm', function(event) {
				$('#comments [data-uri]').trigger('refresh');
			});

			$('body').on('manifestation-embed-change', 'form.badge-form', function(event, data) {
				var tab = $(this).closest('#share');

				var url = 'opac/detail/embed/' + $(this).closestData('manid');
				$.get(url, data).done(function(result){
					tab.find('iframe').replaceWith(result);
					tab.find('textarea').val(result);
				})
			});

			$('body').on('shown.bs.modal', '#badge-preview', function(event) {
				var iframe = $(this).find('iframe[data-src]');

				if (iframe.length) {
					iframe.attr('src', iframe.attr('data-src'));
					iframe.removeAttr('data-src');
				}
			});

			$("body").on('focus', '.manifestation-embed-modal textarea', function() {
				$(this).select();
			});

			// Scroll and open items panel when clicking the items number button
			$("body").on("click", "li.items", function() {
				dng.scrollAndOpenPanel("#items");
			});

			// The same for issues
			$("body").on("click", "li.issues", function() {
				dng.scrollAndOpenPanel("#issues");
			});
		});
	});
});
define("manifestation", function(){});

